import moment from 'moment';

export function getMealsForDay(meals: any, date: any) {
    if (!meals) return [];
    return meals.filter((meal: any) => moment(meal.date).isSame(date, 'day'));
}

export function getMealsForDateRange(meals: any, startDate: any, endDate: any) {
    if (!meals) return [];
    return meals.filter((meal: any) => moment(meal.date).isBetween(moment(startDate), moment(endDate), 'day', '[]'));
}
